<template>
  <CardsSectionBlock named>
    <template #block-name>
      <PackName :pack-name="account.pack_name" :pack-icon="account.pack_icon.default" />
    </template>
    <!-- block items in grid ( free slot ) ⤵ -->
    <CardSingle v-for="card in sortedByCreatedDate" :key="card.id" :card="card" />
    <!-- cards slots -->
    <SlotButton
      v-for="slot in freeSlots"
      :key="`slot-${slot}`"
      :text="$t('actions.add')"
      :to="{ name: 'add-card-modal' }"
    >
      <AppIcon icon="fal fa-plus-circle" />
    </SlotButton>
    <!-- expand pack button -->
    <SlotButtonLock
      v-if="isUpgradeable"
      :text="$t('suscriptions.upgrade')"
      key="expand-pack-button"
      @click.native.prevent="openRoute"
    />
  </CardsSectionBlock>
</template>

<script>
// Utilities
import { mapState } from 'vuex'
import { sortArrayByObjectKey } from 'Utils'
import { packsSettings } from 'Utils/config/diy'
import { clientGetters } from 'Store/helpers'
// Components
import AppIcon from 'Ui/AppIcon'
import PackName from 'Components/PackName'
import SlotButton from 'Components/SlotButton'
import CardSingle from 'Modules/Card/CardSingle'
import SlotButtonLock from 'Components/SlotButtonLock'
import CardsSectionBlock from 'Components/CardsSectionBlock'

export default {
  name: 'CardsSectionClientActivesPack',

  components: {
    AppIcon,
    PackName,
    SlotButton,
    CardSingle,
    SlotButtonLock,
    CardsSectionBlock,
  },

  methods: {
    openRoute() {
      window.open(packsSettings.suscriptions_url)
    },
  },

  computed: {
    ...mapState('client', ['account', 'cards', 'freeSlots']),
    ...clientGetters,

    isUpgradeable() {
      return this.account.pack_name !== 'modo turbo'
    },

    sortedByCreatedDate() {
      return sortArrayByObjectKey(this.getActivePackCards, 'created')
    },
  },
}
</script>

<style scoped></style>
